import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { ErrorContainerService } from '../../../../shared/components/error-container/error-container.service';
import { BrowseFormService } from './browse-form.service';
import { SearchObjectService, SearchObject } from '../../../../shared/services/search-object.service';
import { LoadingScreenService } from 'src/app/shared/components/loading-screen/loading-screen.service';
import { NetworkTypes, QueryTerms } from 'src/app/shared/models/QueryTerms';
import { SearchOptionTypes } from 'src/app/shared/models/FIlterTerms';

@Component({
  selector: 'app-browse-form',
  templateUrl: './browse-form.component.html',
  styleUrls: ['./browse-form.component.scss']
})
export class BrowseFormComponent implements OnInit, OnDestroy {
  searchViaFilterSubscription;
  careTypes = [];
  searchObject: SearchObject;
  coverageTypesData: Object;
  isClient: boolean;
  isCigna: boolean;
  error: any = {
    careTypeMsg: ''
  };

  @Input() loggedIn: boolean;
  @Input() isLoginPage: boolean;
  @Input() isPCPSearch: boolean;
  @Input() isShop: boolean;
  @Input() isEmployer: boolean;
  @Input() queryParamMap;
  @Input() providerName;
  @Input() providerErrorMsg;
  @Input() providerPhoneNumber;
  @Input() clickedSearchCriteria;

  constructor(private ref: ChangeDetectorRef, private loadingScreenService: LoadingScreenService,
    private browseService: BrowseFormService,
    private errorService: ErrorContainerService,
    private searchObjectService: SearchObjectService) {
    this.searchViaFilterSubscription = this.searchObjectService.searchViaFilters.subscribe(() => {
      this.resetSearchForm();
    });
  }

  ngOnInit() {
    if (this.queryParamMap) {
      this.searchObjectService.setSearchObjectQuery(this.queryParamMap);
      if (this.queryParamMap.params[QueryTerms.network] == NetworkTypes.Cigna) {
        this.isCigna = true;
      }
    }
    this.searchObject = this.searchObjectService.getSearchObject();

    if (!this.isPCPSearch) {

      //**Member Login Handler *//
      if (this.isLoginPage && this.searchObject && this.searchObject.memberObject && this.searchObject.memberObject.careTypes && this.searchObject.memberObject.careTypes.length !== 0) {
        const len = this.searchObject.memberObject.careTypes.length;
        const careTypes = [];
        for (let i = 0; i < len; i++) {
          careTypes.push(this.searchObject.memberObject.careTypes[i]);
          if (i === len - 1) {
            this.careTypes = careTypes;
          }
        }
        if (this.queryParamMap && this.queryParamMap.params[QueryTerms.networkid]) {
          this.updateLoginSelect(this.queryParamMap.params[QueryTerms.networkid]);
        }
        if (this.isCigna) {
          this.updateLoginSelect('0000010000010001100011');
          this.searchObject.careType = this.searchObject.memberObject.careTypes[0].careType;
        }
      } else {
        this.loadingScreenService.toggleLoaderOn();
        this.browseService.getCareTypes().subscribe(data => {
          this.careTypes = data.careTypes;
          this.setCoverageTypesData();
          this.loadingScreenService.toggleLoaderOff();
        },
          error => {
            this.error.careTypeMsg = 'Error loading values. Please try again.';
          });
      }
    }
  }

  ngOnDestroy() {
    if (this.searchViaFilterSubscription) {
      this.searchViaFilterSubscription.unsubscribe();
    }
  }

  updateSelect(event) {
    if (!this.searchObject.careType || this.searchObject.careType !== event.target.value) {
      this.searchObject.networkId = undefined;
      this.searchObject.altDestinationUrl = undefined;
      this.searchObject.specialty = undefined;
      this.searchObject.careType = undefined;
      this.searchObject.userInput = '';
      this.searchObject.providerType = null;
      this.searchObject.filters.subProductKey = null;
    }
    this.searchObject.searchOption = SearchOptionTypes.specialty;
    // set saved member caretypes object into UI
    if (this.searchObject.memberObject.loggedIn && this.searchObject.memberObject.careTypes) {
      const len = this.searchObject.memberObject.careTypes.length;
      let networkId = event.target.value;
      let subProductKey = null;
      if (networkId && networkId.includes('_subProductKey_')) {
        let values = networkId.split('_subProductKey_');
        networkId = values[0];
        subProductKey = values[1];
      }
      for (let i = 0; i < len; i++) {
        if (this.searchObject.memberObject.careTypes[i].networkId === networkId && (!subProductKey || subProductKey == this.searchObject.memberObject.careTypes[i].subProductKey)) {
          this.searchObject.networkId = this.searchObject.memberObject.careTypes[i].networkId;
          if (!this.searchObject.memberObject.careTypes[i].shouldDisplayPlanYearPicker || this.isPCPSearch) {
            this.searchObject.filters.subProductKey = this.searchObject.memberObject.careTypes[i].subProductKey;
          }
          this.searchObject.isServiceAreaSearch = this.searchObject.memberObject.careTypes[i].isServiceAreaSearch;
          if (this.searchObject.memberObject.careTypes[i].altDestinationUrl) {
            this.searchObject.altDestinationUrl = this.searchObject.memberObject.careTypes[i].altDestinationUrl;
          }
          this.searchObject.isMultiSpecialtySearch = this.searchObject.memberObject.careTypes[i].isMultiSpecialtySearch;
          this.searchObject.careType = this.searchObject.memberObject.careTypes[i].careType;
        }
      }
    } else {
      this.searchObject.careType = event.target.value;
    }
    this.setCoverageTypesData();
  }

  setCoverageTypesData() {
    this.coverageTypesData = [];
    if (this.searchObject.careType && this.careTypes && this.careTypes.length !== 0) {
      const _len = this.careTypes.length;
      for (let i = 0; i < _len; i++) {
        if (this.searchObject.careType === this.careTypes[i].name) {
          this.coverageTypesData = this.careTypes[i].coverageTypes;
          break;
        }
      }
    }
  }

  updateLoginSelect(networkId) {
    if (this.searchObject.memberObject.loggedIn && this.searchObject.memberObject.careTypes) {
      const len = this.searchObject.memberObject.careTypes.length;
      for (let i = 0; i < len; i++) {
        if (this.searchObject.memberObject.careTypes[i].networkId === networkId) {
          this.searchObject.networkId = this.searchObject.memberObject.careTypes[i].networkId;
          if (!this.searchObject.memberObject.careTypes[i].shouldDisplayPlanYearPicker) {
            this.searchObject.filters.subProductKey = this.searchObject.memberObject.careTypes[i].subProductKey;
          }
          this.searchObject.isServiceAreaSearch = this.searchObject.memberObject.careTypes[i].isServiceAreaSearch;
          this.searchObject.isMultiSpecialtySearch = this.searchObject.memberObject.careTypes[i].isMultiSpecialtySearch;
        }
      }
    }
    this.setCoverageTypesData();
  }


  validateLogin() {
    this.errorService.add('adding error test');
  }

  resetSearchForm() {
    this.searchObject = this.searchObjectService.getSearchObject();
  }

}
